<template>
  <div class="flex h-screen flex-col bg-gob py-5">
    <loader v-if="loader"></loader>
    <modal_component v-if="alert" @close="alert = false">
      <h3 slot="header"></h3>
      <div slot="body" class="text-fodesModalText">
        <div>
          <div class="font-bold pb-2">Número de Identificación Tributaria (NIT)</div>
          <div class="pb-2 ">{{ informacion_empresa.nit }}</div>
          <div class="font-bold ">Número de Registro de Contribuyente (NRC)</div>
          <div class="divide-y divide-separatorColor">
            <div class="pb-2 ">{{ informacion_empresa.nrc }}</div>
            <p></p>
          </div>
        </div>
        <div class="pt-2">
          <p class="text-center">
            Se ha encontrado el registro previo de la empresa.
            Actualmente se encuentra en proceso de: <b>{{ informacion_empresa.nombre_estado }}.</b>
          </p>
          <p class="text-center pb-6">
            ¿Desea agregar sus servicios como <b>{{ nuevo_tipo }}</b>?
          </p>
        </div>
      </div>
      <div slot="footer" class="grid grid-cols-2 font-bold">
        <button class="text-textHead uppercase focus:outline-none font-bold" @click="alert = false">Cancelar</button>
        <button class="text-bodyFodes uppercase focus:outline-none font-bold" @click="GuardarData()">Aceptar</button>
      </div>
    </modal_component>
    <gmodal v-if="success === true">
      <div slot="header"></div>
      <div slot="body">
        <p>La empresa con NIT: <b class="text-bodyFodes">{{ nit.value }}</b> y NRC: <b class="text-bodyFodes">{{
          rnc.value }}</b> ya ha sido registrada, por favor
          siga las indicaciones que le seran enviadas
          por correo electronico</p>
      </div>
      <div slot="footer" class="text-center pt-4">
        <button
          class="text-white uppercase bg-bodyFodes font-bold   font-bold py-3 px-16 rounded-full focus:outline-none"
          @click="success = false">
          ACEPTAR
        </button>
      </div>
    </gmodal>
    <div class="w-11/12 sm:w-1/2 md:w-1/2 lg:w-2/4 m-auto">
      <div class="mb-3">
        <img src="../../../assets/img/logo-white-escudo.svg" alt="" class="d-block mx-auto w-60 lg:w-2/5">
      </div>

      <div class="grid grid-cols-1 place-items-center gap-4">

        <div class="grid grid-cols-1 px-2">
          <p class="text-center text-white font-semibold xs:col-span-1 xl:col-span-2 lg:col-span-2 text-lg mb-8">
            Con base en la normativa vigente de la Dirección Nacional de Obras Municipales los proveedores deben
            registrarse para poder participar de las oportunidades de negocios publicadas en la web.
            Ingresar el NIT y NRC de la persona natural o jurídica.
          </p>
          <div class="py-2 flex gap-4 justify-start" v-if="providerTypeOptions.length > 0">
            <label class="text-white text-sm font-semibold">Procesos en los que desea participar: </label>
            <label class="flex text-center  " v-for="row in providerTypeOptions" :key="row.id">
              <input type="radio" class=" grid rounded w-6 h-6 justify-center items-center mr-2
                focus-within:border-primary" v-model:value="providerTypeId" :value="row.id" name="radio" :id="row.id"
                @click="setType(row.id)" checked />
              <div class="select-none text-white text-sm font-semibold">{{ row.name }}</div>
            </label>
          </div>
        </div>




        <div class="flex flex-wrap gap-4 px-2">
          <div class="flex-1 min-w-[200px]">
            <SelectComponent class="text-white text-sm font-semibold w-40" label="Tipo persona"
              :options="tipo_personeria_options" :placeholder="'Seleccionar'" input-value="id" input-label="nombre"
              v-model="tipopersona" :state="null">
            </SelectComponent>
          </div>

          <div class="flex-1 min-w-[200px]" v-if="tipopersona === 1">
            <label class="text-white text-sm font-semibold">DUI</label>
            <inputcomponent v-model="nit.value" placeholder="00000000-0" v-mask="'########-#'" :errorborder="nit.state">
            </inputcomponent>
            <p v-if="nit.state === true" class="text-red-400">{{ mensaje }}</p>
          </div>


          <div class="flex-1 min-w-[200px]" v-if="tipopersona === 2">
            <label class="text-white text-sm font-semibold">Número de Identificación Tributaria (NIT)</label>
            <inputcomponent v-model="nit.value" placeholder="0000-000000-000-0" v-mask="'####-######-###-#'"
              :errorborder="nit.state">
            </inputcomponent>
            <p v-if="nit.state === true" class="text-red-400">{{ mensaje }}</p>
          </div>


          

          <div class="flex-1 min-w-[200px]">
            <label class="text-white text-sm font-semibold">Número de Registro de Contribuyente (NRC)</label>
            <input type="text" v-model="nrcs" placeholder="0000-0"
              class="block w-full py-1 px-3 pr-5 mt-1 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
              :class="rnc.state === true ? 'border-red-500' : ''" @input="changeMask($event.target.value)"
              v-mask="maskara" required />
            <p v-if="rnc.state == true" class="text-red-400">{{ mensaje }}</p>
          </div>
        </div>





        <div v-if="showType === true" class="py-4 flex items-center text-center gap-4">
          <label class="flex text-center" v-for="row in tipos" :key="row.id">
            <input type="checkbox" class="rounded w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 ml-4
                focus-within:border-primary" :value="row.id" :id="row.id" @click="check($event, row)" />
            <div class="select-none text-grayGob font-semibold">{{ row.nombre }}</div>
          </label>
        </div>



        <p v-if="ejecutor.value === true && supervisor.value === true" class="text-red-300 pl-10 uppercase">
          {{ mensajeChecks }}</p>
        <p v-if="ejecutor.value === false && supervisor.value === false && this.showType === true || this.providerTypeId === null"
          class="text-red-300 pl-10 uppercase">
          {{ mensajeChecks2 }}</p>

        <div class="flex justify-center py-3">
          <button class="bg-white text-gob font-bold py-3 px-16 rounded-full focus:outline-none" @click="getEmpresa()">
            Registrar empresa
          </button>
        </div>
      </div>











    </div>
  </div>
</template>

<script>
import Modal_component from "../../../components/modal_component";
import { mapGetters } from "vuex";
import SelectComponent from "../../../components/SelectComponent";
import { maskDui, isDui, maskNit, isNit, isEmail, numberFormat } from '@/plugins/shared'

export default {
  components: { Modal_component, SelectComponent },
  data: () => ({
    // url:'https://api-fd-dev.salud.gob.sv',
    loader: false,
    url: process.env.VUE_APP_API_URL,
    tipos: [],
    maskara: null,
    antiguo: 1,
    providerTypeId: 1,
    ejecutor: {
      value: false,
      state: false
    },
    supervisor: {
      value: false,
      state: false
    },
    alert: false,
    success: false,
    dui: {
      value: null,
      state: null
    },
    nit: {
      value: null,
      state: null
    },
    rnc: {
      value: null,
      state: null
    },
    nits: null,
    nrcs: null,
    nrfinal: null,
    tipo_empresa: [],
    providerTypeOptions: [],
    informacion_empresa: {
      id_empresa: {
        value: null,
        state: null,
        message: 'Nombre de empresa es requerido *'
      },
      nombre_empresa: {
        value: null,
        state: null,
        message: 'Nombre de empresa es requerido *'
      },
      experiencia: {
        value: null,
        state: null,
        message: 'Experiencia es requerido *'
      },
      numero_registro: {
        value: null,
        state: null,
        message: 'Numero de registro es requerido *'
      },
      foto_numero_registro: {
        value: null,
        state: null,
        message: 'Escaneo numero de registro requerido *'
      },
      nombre_comercial_empresa: {
        value: null,
        state: null,
        message: 'nombre comercial es requerido *'
      },
      pais_origen_empresa: {
        value: null,
        name: null,
        state: null,
        message: 'País de origen de la empresa es requerido *'
      },
      tipo_personeria: {
        value: null,
        state: null,
        name: null,
        message: 'Tipo de personería es requerido *'
      },
      numero_nit: {
        value: null,
        state: null,
        message: 'Numero de NIT es requerido *'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'Escaneo numero de NIT es requerido *'
      },
      tamano_empresa: {
        value: null,
        state: null,
        name: null,
        message: 'Clasificación de la empresa es requerido *'
      },
      numero_matricula_comercial: {
        value: null,
        state: null,
        message: 'Numero de matricula comercial es requerido *'
      },
      foto_matricula_comercial: {
        value: null,
        state: null,
        message: 'Escaneo de matricula comercial es requerido *'
      },
      numero_iva: {
        value: null,
        state: null,
        message: 'Numero de iva es requerido *'
      },
      foto_iva: {
        value: null,
        state: null,
        message: 'Escaneo de iva es requerido *'
      },
      giros: {
        value: [],
        state: null,
        message: 'Giros de empresa es requerido *'
      },
    },
    dato_contacto: null,
    configuracion: {
      type: Object,
      default: {
        text_color: 'text-white',
        bg_color: 'bg-alertSucess',
      }
    },
    mensaje: '',
    mensajeChecks: '',
    mensajeChecks2: '',
    showType: true,
    nuevo_tipo: '',
    nuevo_tipo_id: null,
    tipo_personeria_options: [],
    tipopersona: null,
    tipopersoneria: {
      value: null,
      state: null,
      name: null,
    },
  }),
  methods: {
    getEmpresasPersonerias() {
      axios.get(this.url + '/api/v1/empresas/personerias',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.tipo_personeria_options = response.data
        });
    },
    onKeyDownHandler(event, value, tipo) {
      if (value !== null && value !== '') {
        let codigo = event.which || event.keyCode;
        if (tipo === 1) {
          if (codigo === 8) {
            this.nits = null
            this.nit.value = null
          }
        }
        if (tipo === 2) {
          if (codigo === 8) {
            this.rnc.value = null
            this.nrcs = null
          }
        }
      }
    },
    async GuardarData() {
      let empresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      const response = await this.http_client('/api/v1/empresas/' + empresa.id, { "tipos": [{ 'id_tipo_empresa': this.nuevo_tipo_id }, { 'id_tipo_empresa': empresa.tipos[0].id_tipo_empresa }] }, 'put')
      window.localStorage.setItem('InfoEmpresas', JSON.stringify(this.informacion_empresa));
      this.$router.push('/empresas/registro')
    },
    changeMask(e) {
      this.maskara = []
      if (e) {
        this.maskara.length = e.length + 1
        this.maskara.fill(/\d/)
        this.maskara[e.length - 2] = '-'
      }
    },
    setType(valueId) {
      if (valueId === 1) {
        this.providerTypeId = valueId
        this.showType = true
      } else {
        this.showType = false
      }
    },
    getProviderType() {
      axios.get(this.url + '/api/v1/empresasType',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.providerTypeOptions = response.data

        });
    },

    validateNitEmpresa() {
      let respuesta = false
      if (this.nit.value === null || this.nit.value === "") {
        this.nit.state = true
        respuesta = false
      } else if (isNit(this.nit.value) || isDui(this.nit.value)) {

        respuesta = true
      } else {

        this.nit.message = 'NIT no valido'
        respuesta = false
      }
      return respuesta
    },

    validateDuiEmpresa() {
      let respuesta = false
      if (this.nit.value === null || this.nit.value === "") {
        this.nit.state = true
        respuesta = false
      } else if (isDui(this.nit.value)) {

        respuesta = true
      } else {

        this.nit.message = 'DUI no valido'
        respuesta = false
      }
      return respuesta
    },

    validateNRCEmpresa() {

      let respuesta2 = false
      if (this.nrcs === null || this.nrcs === "") {

        this.rnc.state = true
        respuesta2 = false
      } else {
        if (this.nrcs.length <= 1 || this.nrcs.length > 14) {

          this.rnc.message = 'NRC debe ser igual o menor a trece digitos y mayor que uno'
          respuesta2 = false
        } else {
          respuesta2 = true
        }
      }
      return respuesta2
    },
    async getEmpresa() {
      this.loader = true
      // let validaNit = this.tipopersona === null ? false : this.tipopersona === 1 ? this.validateDuiEmpresa() : this.validateNitEmpresa()
      let validaNit = this.validateNitEmpresa()
      let validaNRC = this.validateNRCEmpresa()
      if (validaNit && validaNRC) {
        this.rnc.value = this.nrcs

        this.mensaje = 'rellene el campo obligatorio *'
        let tipo = 0
        if (this.providerTypeId === 2) {
          if (this.nit.value !== null && this.nit.value !== '' && this.rnc.value !== null && this.rnc.value !== '' && this.providerTypeId !== null) {
            if (this.tipo_empresa == null && this.tipo_empresa.length === 0 && this.providerTypeId == null) {
              this.mensajeChecks2 = 'Seleccione el tipo de empresa *'
            }

            if (this.tipo_empresa !== null) {
              this.loader = true
              axios.get(this.url + '/api/v1/providers/validNIT?' +
                'nit=' + this.nit.value + '&nrc=' + this.rnc.value,
                {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }).then((response) => {
                  window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa));
                  let tipos = []
                  let tipoEmpresa = this.providerTypeId
                  if (tipoEmpresa == 1) {
                    let tiposarr = this.tipo_empresa
                    tiposarr.forEach(row => {
                      tipos.push({ 'id': row.id, "id_tipo_empresa": row.id, "nombre_tipo_empresa": row.nombre })
                    })
                    this.informacion_empresa = { 'nit': this.nit.value, 'nrc': this.rnc.value, tipos, tipoEmpresa, 'tipopersona': this.tipo_persona, 'tipo_personeria': this.tipopersoneria }
                  } else {
                    this.informacion_empresa = { 'nit': this.nit.value, 'nrc': this.rnc.value, tipoEmpresa, 'tipopersona': this.tipopersona, 'tipo_personeria': this.tipopersoneria }
                  }


                  window.localStorage.setItem('InfoEmpresas', JSON.stringify(this.informacion_empresa));
                  if (this.$route.params.id === 'proceso') {
                    this.$router.push('/empresas/registro/proceso')
                  } else {
                    this.$router.push('/empresas/registro')
                  }
                  // }
                }).catch(error => {
                  if (error.response.status === 400) {

                    this.$toast.warning(error.response.data.message)
                    this.loader = false
                    return false
                  }
                }).finally()
              {
                this.loader = false
              }
              ;
            }
          } else {
            this.nit.value == null || this.nit.value === '' ? this.nit.state = true : this.nit.state = false
            this.rnc.value == null || this.rnc.value === '' ? this.rnc.state = true : this.rnc.state = false
            this.ejecutor.value == null || this.ejecutor.value === '' &&
              this.tipo_empresa == null || this.providerTypeId == null ? this.mensajeChecks2 = 'Seleccione un tipo de empresa, campo obligatorio *' : this.mensajeChecks = null
          }
        } else {
          if (this.nit.value !== null && this.nit.value !== '' && this.rnc.value !== null && this.rnc.value !== '' && this.tipo_empresa.length !== 0) {
            if (this.tipo_empresa == null && this.tipo_empresa.length === 0 && this.showType === true) {
              this.mensajeChecks2 = 'Seleccione un tipo de empresa, campo requerido *'
            }
            if (this.tipo_empresa !== null) {
              this.loader = true
              axios.get(this.url + '/api/v1/providers/validNIT?' +
                'nit=' + this.nit.value + '&nrc=' + this.rnc.value,
                {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }).then((response) => {
                  window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa));
                  let tipos = []
                  let tipoEmpresa = this.providerTypeId
                  if (tipoEmpresa == 1) {
                    let tiposarr = this.tipo_empresa
                    tiposarr.forEach(row => {
                      tipos.push({ 'id': row.id, "id_tipo_empresa": row.id, "nombre_tipo_empresa": row.nombre })
                    })
                    this.informacion_empresa = { 'nit': this.nit.value, 'nrc': this.rnc.value, tipos, tipoEmpresa, 'tipopersona': this.tipopersona, 'tipo_personeria': this.tipopersoneria }
                  } else {
                    this.informacion_empresa = { 'nit': this.nit.value, 'nrc': this.rnc.value, tipoEmpresa, 'tipopersona': this.tipopersona, 'tipo_personeria': this.tipopersoneria }
                  }


                  window.localStorage.setItem('InfoEmpresas', JSON.stringify(this.informacion_empresa));
                  if (this.$route.params.id === 'proceso') {
                    this.$router.push('/empresas/registro/proceso')
                  } else {
                    this.$router.push('/empresas/registro')
                  }
                  // }
                }).catch(error => {
                  if (error.response.status === 400) {

                    this.$toast.warning(error.response.data.message)
                    this.loader = false
                    return false
                  }
                }).finally()
              {
                this.loader = false
              }
              ;
            }
          } else {
            this.nit.value == null || this.nit.value === '' ? this.nit.state = true : this.nit.state = false
            this.rnc.value == null || this.rnc.value === '' ? this.rnc.state = true : this.rnc.state = false
            this.ejecutor.value == null || this.ejecutor.value === '' &&
              this.tipo_empresa == null || this.tipo_empresa.length === 0 ? this.mensajeChecks2 = 'Seleccione un tipo, campo obligatorio *' : this.mensajeChecks = null
          }
        }
      } else {
        if (!validaNit) {
          this.$toast.error(this.tipopersona === 2 ? 'El número de NIT no es válido' : 'El número de DUI no es válido')
          this.loader = false
          return false
        }
        if (!validaNRC) {
          this.$toast.error('NRC debe ser igual o menor a trece dígitos y mayor a uno ')
          this.loader = false
          return false
        }
      }
      this.loader = false
    },





    getTipos() {
      axios.get(this.url + '/api/v1/empresas/tipo',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.tipos = response.data;
        });
    },
    check(e, data) {
      if (e.target.checked === true) {
        this.tipo_empresa.push(data)
      }
      if (e.target.checked === false) {
        this.tipo_empresa.splice(this.tipo_empresa.indexOf(data.id), 1)
      }
    },
    formatterr() {
      let r = this.nrcs
      let regexp1 = '^(\\\d{'
      let regexp2 = '})(\\\d{1})'
      let regex = new RegExp(/^(\d{6})(\d{1}).*/, 'gi')
      if (r.length > 1) {
        let regexFinal = new RegExp(regexp1 + (this.nrcs.length - 1) + regexp2, 'gi')
        r = r.replace(regexFinal, "$1-$2");
        this.nrcs = r
      }
    },
    verificarInformacion() {
      if (window.localStorage.getItem('InfoEmpresas')) {
        if (!!this.$route.params.id) {
          this.$router.push('/empresas/registro/1')
        } else {
          this.$router.push('/empresas/registro')
        }

      }
    },
    clearLocalStorage() {
      this.$store.dispatch('Fodes/reiniciarDataFotos', 1)
    }
  },
  computed: {
    ...mapGetters({
      isnitvalid: "Fodes/getIsNitValid",
      //isnitvalid: this.tipopersona === 1 ? "Fodes/getIsDuiValid" : "Fodes/getIsNitValid",
    }),
  },
  beforeMount() {
    this.clearLocalStorage()
  },
  mounted() {
    this.getTipos()
    this.verificarInformacion()
    this.getProviderType()
    this.getEmpresasPersonerias()
  },
  watch: {
    tipopersona: function (val) {
      this.tipopersoneria.value = val
      // console.log('tipo_personeria_options: ', this.tipo_personeria_options)
      // const item = this.tipo_personeria_options.find(option => option.id === val);
      // const item = this.tipo_personeria_options.find(option => option.id === Number(val));

      // console.log(`Nombre encontrado: ${this.tipo_personeria_options[0].value.name}`);

      const options = JSON.parse(JSON.stringify(this.tipo_personeria_options));

      // Buscar el objeto cuyo id sea igual a val
      const item = options.find(option => option.id === val);

      this.tipopersoneria.name = item.nombre

    },
  }
}

</script>
<style>
input:checked+svg {
  display: block;
}
</style>
